import chessMark from "../assets/onlychess-mark.svg";
import whiteKing from "../../../assets/chess-pieces/white-king.svg";
import whiteQueen from "../../../assets/chess-pieces/white-queen.svg";
import whiteRook from "../../../assets/chess-pieces/white-rook.svg";
import whiteBishop from "../../../assets/chess-pieces/white-bishop.svg";
import whiteKnight from "../../../assets/chess-pieces/white-knight.svg";
import whitePawn from "../../../assets/chess-pieces/white-pawn.svg";
import blackKing from "../../../assets/chess-pieces/black-king.svg";
import blackQueen from "../../../assets/chess-pieces/black-queen.svg";
import blackRook from "../../../assets/chess-pieces/black-rook.svg";
import blackBishop from "../../../assets/chess-pieces/black-bishop.svg";
import blackKnight from "../../../assets/chess-pieces/black-knight.svg";
import blackPawn from "../../../assets/chess-pieces/black-pawn.svg";

export const brandAssets = { brandAccent: "", brandMark: chessMark, favicon: chessMark, appleTouchIcon: chessMark };
export const deliveryAssets: Record<string, string> = {
  "/arena-roster/azure-fan/avatar.webp": whiteKing,
  "/arena-roster/violet-shadow/avatar.webp": whiteQueen,
  "/arena-roster/obsidian-blood/avatar.webp": whiteRook,
  "/arena-roster/rose-thorn/avatar.webp": whiteBishop,
  "/arena-roster/crimson-chainblade/avatar.webp": whiteKnight,
  "/arena-roster/ivory-frost/avatar.webp": whitePawn,
  "/arena-roster/jade-serpent/avatar.webp": blackKing,
  "/arena-roster/golden-sun/avatar.webp": blackQueen,
  "/arena-roster/silver-moonblade/avatar.webp": blackRook,
  "/arena-roster/copper-arena/avatar.webp": blackBishop,
  "/arena-roster/cobalt-storm/avatar.webp": blackKnight,
  "/arena-roster/inferno-twinblade/avatar.webp": blackPawn,
};
export const hijabDeliveryAssets: Record<string, string> = {};
